import { render, staticRenderFns } from "./titleRibbon.vue?vue&type=template&id=52172a52&scoped=true"
import script from "./titleRibbon.vue?vue&type=script&lang=js"
export * from "./titleRibbon.vue?vue&type=script&lang=js"
import style0 from "./titleRibbon.vue?vue&type=style&index=0&id=52172a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52172a52",
  null
  
)

export default component.exports